import { types, flow } from 'mobx-state-tree'

import SBUser from '~/stores/models/SBUser'
import SBAgent from '~/stores/models/SBAgent'
import SBCustomer from '~/stores/models/SBCustomer'

import * as ChatService from '~/services/chat'

export const ChatStore = types
  .model('ChatStore', {
    user: types.optional(SBUser, {}),
    agent: types.optional(SBAgent, {}),
    customer: types.optional(SBCustomer, {}),
    currentChannelUrl: types.optional(types.string, ""),
    chatWindowShowing: false,
  })
  .actions(self => ({
    initialize: flow(function* initializeGen(attorneyId, ticketId) {
      const SBuser = yield ChatService.createUser(attorneyId, ticketId)
      if (Object.keys(SBuser || []).length) {
        self.setUser(SBuser)
        const result = yield ChatService.autoJoinSendbirdUserToHisGroupChannel(attorneyId, ticketId)
        self.setCurrentChannelUrl(result.channelUrl)
      }
    }),
    getChatHistoryLength: flow(function* getChatHistoryLengthGen(ticketId) {
      const chatHistory = yield ChatService.historyForGroupChannel(ticketId)
      return chatHistory.totalExistingChannelMessages
    }),
    setUser(user) {
      self.user = user
    },
    setAgent(agent) {
      self.agent = agent
    },
    setCustomer(customer) {
      self.customer = customer
    },
    setChatWindowShowing(bool) {
      self.chatWindowShowing = bool
    },
    setCurrentChannelUrl(slug) {
      self.currentChannelUrl = slug
    }
  }))
  .views(self => ({
    // get someComputedProperty(){},
  }))
